

export const isLocalDev = process.env.NODE_ENV !== 'production';